<script>
	import Panel1 from './components/Panel1.svelte'
	import Panel2 from './components/Panel2.svelte'
</script>

<main>
	<div class="panels">
		<section id="p1"><Panel1 /></section>
		<section id="p2"><Panel2 /></section>
	</div>
</main>

<footer>
	<nav class="nav">
		<ul>
		  	<li><a href="#p1">MAIN TREE</a></li>
			<li><a href="#p2">SIMILAR</a></li>
		</ul>    
	</nav>
</footer>

<style lang="scss">
@import "./base/_config.scss";

main, footer {position:absolute; left:0; right:0;}
footer {height:36px; background: rgba(0,0,0,0.75); color:#fff; padding: 2px 16px; bottom:0;}
main {top:0px; bottom:36px;}

.panels {
  _background: #999;
  display: flex;
  overflow: auto;
  width: 100%;
  height: 100%;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.panels > section {
  position: relative;
  flex: 0 0 100%;
  height: 100%;
  overflow: auto;
  font-size: 18px;
  scroll-snap-align: start;
}

.nav ul {display:flex; height:36px;}
.nav li {width:25%; list-style:none; text-align:center; height:36px;}
.nav a {display:block; height:36px; line-height:36px; color:#fff; text-decoration:none; font-size:16px;}
.nav a:hover {background: #555;}

@media (min-width: 768px) {
  .panels > section {
    flex: 0 0 50%;
  }
}

@media (min-width: 1360px) {
  .panels > section {
    flex: 0 0 33.33333333%;
  }
}

</style>